<template>
  <div class="search-content">
    <el-row class="ListMenu">
      <el-col>
        <el-form
          ref="form"
          :model="listMenuForm"
          class="searchForm orderSelect"
        >
          <el-form-item class="searchItem">
            <el-select v-model="orderChoice" @change="handleSelectChange">
              <el-option label="訂單編號" value="orderId"></el-option>
              <el-option label="會員帳號" value="userEmail"></el-option>
              <el-option label="貨運單號" value="trackingNumber"></el-option>
              <el-option label="姓名" value="name"></el-option>
              <el-option label="手機" value="mobile"></el-option>
            </el-select>
            <el-input
              style="marginleft: 5px"
              placeholder="在左側選擇搜索類別"
              v-model="listMenuForm[orderChoice]"
              @change="handleInputChange(orderChoice)"
            >
            </el-input>
          </el-form-item>
          <div class="leftwidth"></div>
          <el-form-item label="開始時間" class="searchItem">
            <el-date-picker
              v-model="listMenuForm.startTime"
              type="datetime"
              placeholder="選擇時間"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="結束時間" class="searchItem">
            <el-date-picker
              v-model="listMenuForm.endTime"
              type="datetime"
              placeholder="選擇時間"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <p
              class="recentlyTitle"
              style="display: inline-block"
              @click="choiceTime()"
            >
              最近31天
            </p>
          </el-form-item>
          <el-form-item
            class="searchItem hidden-lg-and-down"
            :style="{ marginLeft: '-140px' }"
          >
            <el-select v-model="listMenuForm.orderType" placeholder="訂單類型">
              <el-option label="所有商品" value=""></el-option>
              <el-option label="VIP會籍" value="1"></el-option>
              <el-option label="商城" value="4"></el-option>
              <el-option label="扭蛋" value="5"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="ListMenu" style="height: 60px">
      <el-form ref="form" :model="listMenuForm" class="searchForm orderSelect">
        <el-form-item class="searchItem hidden-xl-only">
          <el-select v-model="listMenuForm.orderType" placeholder="訂單類型">
            <el-option label="所有商品" value=""></el-option>
            <el-option label="VIP會籍" value="1"></el-option>
            <el-option label="商城" value="4"></el-option>
            <el-option label="扭蛋" value="5"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- @click="exportOrderExcel" -->
    <div class="MenuBtnWrap_right">
      <div class="btn colorfade" @click="showDold('up')">下載發貨單</div>
      <div
        class="btn colorfade"
        @click="showDold('down')"
        style="margin-left: 0.2rem"
      >
        上傳發貨單
      </div>
      <div class="btn" @click="search()" style="margin-left: 0.2rem">查詢</div>
      <div class="btn borderBtn" @click="reset()" style="margin-left: 0.2rem">
        重置
      </div>
    </div>
    <div class="MenuBtnWrap">
      <div
        class="MenuBtnWrap_left"
        v-if="tags.length !== 0"
        style="marginbottom: 30px"
      >
        <span>搜索结果：</span>
        <div class="tags">
          <el-tag
            v-for="tag in tags"
            :key="tag.name"
            @close="closeTag(tag)"
            closable
          >
            {{ tag.name }}
          </el-tag>
        </div>
      </div>
    </div>
    <div class="tableWrap" style="margintop: 0px">
      <el-table height="660px" stripe :data="orderList" style="width: 100%">
        <template slot="empty">
          <div class="no-data-container">
            <img
              src="@/assets/images/common/no_data.png"
              alt="暂无数据"
              :style="{ width: '244px', height: '139px' }"
            />
          </div>
        </template>
        <el-table-column type="index" label="#" width="50"> </el-table-column>
        <el-table-column
          v-for="(item, index) in orderListTable"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
        >
          <template slot-scope="scope">
            <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
              -
            </div>
            <div
              v-else-if="item.prop === 'orderNum'"
              :style="{ color: '#6C3DEA', cursor: 'pointer' }"
              @click="
                $router.push(
                  '/orderDetails?orderNum=' + scope.row.orderNum + '&status=out'
                )
              "
            >
              {{ scope.row[item.prop] }}
            </div>
            <div v-else-if="item.prop === 'realName'">
              <div>{{ scope.row.realName }}</div>
              <div
                :style="{ color: '#6C3DEA', cursor: 'pointer' }"
                @click="
                  $router.push(
                    '/userDetails?id=' + scope.row.userId + '&status=out'
                  )
                "
              >
                {{ scope.row.email }}
              </div>
            </div>
            <div v-else-if="item.prop === 'orderDetailDtoList'">
              <div
                v-for="(item, index) in scope.row.orderDetailDtoList"
                :key="index"
              >
                {{ item.goodsAmount }} x {{ item.goodsName }}
                {{ item.goodsDetail }}
              </div>
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          label="售後權限"
          v-if="orderStatus == 3"
          width="180"
        >
          <template slot-scope="scope">
            <el-button
              @click="openSalse(scope.row)"
              type="text"
              :disabled="
                scope.row.afterSaleOpen == 1 || scope.row.afterSaleOpen == 3
              "
            >
              {{
                scope.row.afterSaleOpen == 1
                  ? "已開啓"
                  : scope.row.afterSaleOpen == 2
                  ? "已开启但失效可重新开启"
                  : scope.row.afterSaleOpen == 3
                  ? "售後進行中"
                  : "開啓售後"
              }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paging-block clearfix">
      <el-pagination
        class="paging fr"
        hide-on-single-page
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        @size-change="handleSizeChange"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="currentPageSize"
        :pager-count="5"
        layout="sizes, prev, pager, next, jumper "
        :total="total"
      >
      </el-pagination>
    </div>
    <DiaMess v-if="dialogVisible"></DiaMess>
    <el-dialog
      :visible.sync="showMoadl"
      title="提示信息"
      width="500"
      center
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <div v-if="downType == 'up'">
        <div style="text-align: center; font-size: 14px">
          是否下载订单并提交给厂商?提交给厂商后，用户的订单信息将无法修改。
        </div>
        <div class="areaSelect">
          <div style="margin-right: 15px">请选择下载地区</div>
          <el-radio-group v-model="downExcelType">
            <el-radio :label="1" :value="1">大陆</el-radio>
            <el-radio :label="2" :value="2">港澳台新马</el-radio>
            <el-radio :label="3" :value="3">其他地区</el-radio>
          </el-radio-group>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 60px">
          <el-button @click="exportOrderExcel(0)"> 仅下载 </el-button>
          <el-button
            type="primary"
            style="margin-left: 30px"
            @click="exportOrderExcel(1)"
          >
            下载并提交给厂商
          </el-button>
        </div>
      </div>
      <div v-else style="display: flex; align-items: center; color: #000">
        <div style="margin-right: 20px">上傳訂單：</div>
        <el-upload
          class="colorfades"
          name="file"
          ref="excelUpload"
          :action="this.$GLOBAL.orderExcelPostUrl"
          :headers="{ Authorization: this.$cookie.get('auth') }"
          :with-credentials="true"
          :before-upload="beforeExcelUpload"
          :on-remove="handleRemove"
          :on-success="successExcel"
          :on-error="errorExcel"
          :show-file-list="false"
          :multiple="false"
          :file-list="fileList"
          :on-change="fileChange"
          :on-exceed="handleExceed"
          :limit="1"
        >
          <span class="uploadSpan">上傳發貨單</span>
        </el-upload>
        <div
          style="color: #6c3dea; cursor: pointer; margin-left: 20px"
          @click="downloadExcel"
        >
          下載模板
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DiaMess from "@/components/dialog";
import { MessageBox } from "element-ui";
export default {
  props: ["orderStatus"],
  data() {
    return {
      listMenuForm: {
        orderId: "",
        userEmail: "",
        trackingNumber: "",
        name: "",
        mobile: "",
        startTime: "",
        endTime: "",
        orderType: "",
      },
      showMoadl: false,
      downExcelType: 1,
      orderChoice: "userEmail",
      tags: [],
      orderList: [],
      fileList: [],
      orderListTable: [
        {
          prop: "orderStatus",
          label: "出貨狀態",
        },
        {
          prop: "orderNum",
          label: "訂單編號",
        },
        {
          prop: "realName",
          label: "訂購人",
        },
        {
          prop: "address",
          label: "收件地區",
        },
        {
          prop: "orderDetailDtoList",
          label: "品項",
        },
        {
          prop: "trackingNumber",
          label: "貨運單號",
        },
        {
          prop: "createTime",
          label: "創建日期",
        },
      ],
      currentPage: 1,
      currentPageSize: 20,
      total: 10,
      dialogVisible: false,
      downType: "",
    };
  },
  created() {
    this.getOrderList();
  },
  activated() {
    this.getOrderList();
  },
  destroyed() {},
  methods: {
    getOrderList() {
      let _this = this;
      let startTime, endTime;
      if (
        _this.listMenuForm.startTime === "" ||
        _this.listMenuForm.startTime === null
      ) {
        startTime = null;
      } else {
        startTime = _this.$formatDate(_this.listMenuForm.startTime);
      }
      if (
        _this.listMenuForm.endTime === "" ||
        _this.listMenuForm.endTime === null
      ) {
        endTime = null;
      } else {
        endTime = _this.$formatDate(_this.listMenuForm.endTime);
      }
      let param = {
        userEmail:
          _this.listMenuForm.userEmail === ""
            ? null
            : _this.listMenuForm.userEmail,
        orderNum:
          _this.listMenuForm.orderId === "" ? null : _this.listMenuForm.orderId,
        orderStatus: _this.orderStatus === "" ? null : _this.orderStatus,
        orderType:
          _this.listMenuForm.orderType === ""
            ? ""
            : Number(_this.listMenuForm.orderType),
        name: _this.listMenuForm.name === "" ? null : _this.listMenuForm.name,
        mobile:
          _this.listMenuForm.mobile === "" ? null : _this.listMenuForm.mobile,
        trackingNumber:
          _this.listMenuForm.trackingNumber === ""
            ? null
            : _this.listMenuForm.trackingNumber,
        startTime: startTime,
        endTime: endTime,
        pageNo: _this.currentPage,
        pageSize: _this.currentPageSize,
      };
      _this
        .$post(
          "/request/order/v2/getShipmentList",
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          if (res.code === "00000") {
            _this.total = res.data.allRow;
            res.data.list.forEach((v) => {
              v.createTime = _this.$getTime(v.createTime);
              v.area =
                (v.country == null ? "" : v.country) +
                (v.city == null ? "" : v.city);
              v.moneyType = "TWD";
              switch (v.orderType) {
                case "1":
                  v.orderType = "會員入會";
                  break;
                case "2":
                  v.orderType = "活動報名";
                  break;
                case "4":
                  v.orderType = "商城購物";
                  break;
                case "5":
                  v.orderType = "商城購物";
                  break;
              }
              if (v.memberDto == null) {
                v.memberEndTime = "";
              } else if (v.memberDto.endTime == null) {
                v.memberEndTime = "";
              } else {
                v.memberEndTime = v.memberDto.endTime.substring(0, 16);
              }
            });
            _this.orderList = res.data.list;
          } else {
            _this.dialogVisible = true;
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
    },
    handleInputChange(e) {
      this.listMenuForm.trackingNumber =
        this.listMenuForm.trackingNumber.replace(
          /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,
          ""
        );
      this.listMenuForm.userEmail = this.listMenuForm.userEmail.replace(
        /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,
        ""
      );
      this.listMenuForm.orderId = this.listMenuForm.orderId.replace(
        /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g,
        ""
      );
    },
    handleSelectChange() {
      this.listMenuForm.orderId = "";
      this.listMenuForm.userEmail = "";
      this.listMenuForm.trackingNumber = "";
      this.listMenuForm.name = "";
      this.listMenuForm.mobile = "";
    },
    downloadExcel() {
      window.open(
        "https://start.sanctuarytech.co/excel/template/%E4%B8%8A%E4%BC%A0excel.xlsx"
      );
    },
    //关闭搜索条件框
    closeTag(e) {
      this.tags.splice(this.tags.indexOf(e), 1);
      if (e.key === "startTime") {
        this.listMenuForm.startTime = "";
        this.listMenuForm.endTime = "";
      } else {
        this.listMenuForm[e.key] = "";
      }
      this.getOrderList();
    },
    //新增搜索条件框
    tagAdd() {
      let _this = this;
      _this.tags = [];
      let obj = _this.listMenuForm;
      for (let key in obj) {
        if (obj[key] && key !== "orderType") {
          if (key === "orderId") {
            this.tags.push({
              key,
              name: `订单编号：${obj[key]}`,
            });
          } else if (key === "userEmail") {
            this.tags.push({
              key,
              name: `会员帐号：${obj[key]}`,
            });
          } else if (key === "trackingNumber") {
            this.tags.push({
              key,
              name: `货运单号：${obj[key]}`,
            });
          } else if (key === "name") {
            this.tags.push({
              key,
              name: `姓名：${obj[key]}`,
            });
          } else if (key === "mobile") {
            this.tags.push({
              key,
              name: `手机：${obj[key]}`,
            });
          } else if (key === "startTime") {
            this.tags.push({
              key,
              name: `${_this.$formatDate(
                _this.listMenuForm.startTime
              )}-${_this.$formatDate(_this.listMenuForm.endTime)}`,
            });
          }
        } else if (key === "orderType") {
          if (obj[key] === undefined) return;
          let orderTypeName;
          if (obj[key] === "4") {
            orderTypeName = "商城";
          } else if (obj[key] === "5") {
            orderTypeName = "扭蛋";
          } else if (obj[key] === "1") {
            orderTypeName = "VIP会籍";
          } else {
            orderTypeName = "所有商品";
          }
          this.tags.push({
            key,
            name: orderTypeName,
          });
        }
      }
    },
    showDold(type) {
      this.showMoadl = true;
      this.downType = type;
      this.downExcelType = 1;
    },
    // 搜索
    search() {
      //执行搜索校验逻辑
      let _this = this;
      if (
        _this.listMenuForm.name === "" &&
        _this.listMenuForm.mobile === "" &&
        _this.listMenuForm.userEmail === "" &&
        _this.listMenuForm.orderId === "" &&
        _this.listMenuForm.trackingNumber === "" &&
        _this.listMenuForm.startTime === "" &&
        _this.listMenuForm.endTime === "" &&
        _this.listMenuForm.orderType === undefined
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("請輸入至少一個搜索條件", "error", function () {
          _this.dialogVisible = false;
        });

        return false;
      }
      if (
        _this.$compareTime(
          _this.listMenuForm.startTime,
          _this.listMenuForm.endTime
        )
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("開始時間不可以晚於結束時間", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }

      if (_this.$compareTime(_this.listMenuForm.startTime, new Date())) {
        _this.dialogVisible = true;
        _this.$propMessage("開始時間不可以是未來時間", "error", function () {
          _this.dialogVisible = false;
        });

        return false;
      }

      if (_this.$compareTime(_this.listMenuForm.endTime, new Date())) {
        _this.dialogVisible = true;
        _this.$propMessage("結束時間不可以是未來時間", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }

      if (
        (_this.listMenuForm.startTime === "" &&
          _this.listMenuForm.endTime !== "") ||
        (_this.listMenuForm.startTime !== "" &&
          _this.listMenuForm.endTime === "")
      ) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "請同時選擇開始時間和結束時間",
          "error",
          function () {
            _this.dialogVisible = false;
          }
        );
        return false;
      }
      _this.$message.closeAll();
      _this.currentPage = 1;
      _this.tagAdd();
      _this.getOrderList();
    },
    // 重置
    reset() {
      let _this = this;
      _this.listMenuForm = {
        orderId: "",
        userEmail: "",
        trackingNumber: "",
        name: "",
        mobile: "",
        startTime: "",
        endTime: "",
        orderType: "",
      };
      this.tags = [];
      this.orderChoice = "userEmail";
      _this.getOrderList();
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getOrderList();
    },
    handleSizeChange(val) {
      let _this = this;
      _this.currentPageSize = val;
      _this.getOrderList();
    },
    //開啓售後
    openSalse(row) {
      const h = this.$createElement;
      MessageBox.confirm(
        h("div", [
          h("p", { style: "font-size:14px" }, "是否開啓該訂單的售後權限？"),
          h(
            "p",
            { style: "color: #8B64FE;font-size:14px" },
            "訂單號：" + row.orderNum
          ),
          h(
            "p",
            { style: "color: #8B64FE;font-size:14px;" },
            "用戶賬號：" + row.email
          ),
        ]),
        "提示",
        {
          cancelButtonText: "取消",
          confirmButtonText: "開啓",
          center: true,
          showClose: false,
          closeOnClickModal: false,
        }
      ).then(() => {
        this.$post(
          "/request/after/sales/open",
          {
            orderNum: row.orderNum,
          },
          this.$GLOBAL.jsonConfig
        )
          .then((res) => {
            if (res.code == "00000") {
              this.getOrderList();
              this.$successMessage("售後開啟成功");
            } else {
              this.$errorMessage(res.message);
            }
          })
          .catch((err) => {
            this.$errorMessage(err.message);
          });
      });
    },
    // 最近31天
    choiceTime() {
      let _this = this;
      var endTime = new Date();
      var startTime = new Date();
      startTime = startTime.getTime() - 3600 * 1000 * 24 * 31;
      _this.listMenuForm.startTime = new Date(startTime);
      _this.listMenuForm.endTime = endTime;
    },
    // 导出excel
    exportOrderExcel(shipment) {
      let _this = this;
      if (
        _this.listMenuForm.name === "" &&
        _this.listMenuForm.mobile === "" &&
        _this.listMenuForm.userEmail === "" &&
        _this.listMenuForm.orderId === "" &&
        _this.listMenuForm.trackingNumber === "" &&
        _this.listMenuForm.startTime === "" &&
        _this.listMenuForm.endTime === "" &&
        _this.listMenuForm.orderType === undefined
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("請輸入至少一個導出條件", "error", function () {
          _this.dialogVisible = false;
        });

        return false;
      }
      if (
        _this.$compareTime(
          _this.listMenuForm.startTime,
          _this.listMenuForm.endTime
        )
      ) {
        _this.dialogVisible = true;
        _this.$propMessage("開始時間不能晚於結束時間", "error", function () {
          _this.dialogVisible = false;
        });

        return false;
      }

      if (_this.$compareTime(_this.listMenuForm.startTime, new Date())) {
        _this.dialogVisible = true;
        _this.$propMessage("開始時間不能是未來時間", "error", function () {
          _this.dialogVisible = false;
        });

        return false;
      }

      if (_this.$compareTime(_this.listMenuForm.endTime, new Date())) {
        _this.dialogVisible = true;
        _this.$propMessage("結束時間不能是未來時間", "error", function () {
          _this.dialogVisible = false;
        });

        return false;
      }

      if (
        (_this.listMenuForm.startTime === "" &&
          _this.listMenuForm.endTime !== "") ||
        (_this.listMenuForm.startTime !== "" &&
          _this.listMenuForm.endTime === "")
      ) {
        _this.dialogVisible = true;
        _this.$propMessage(
          "請同時選擇開始時間和結束時間",
          "error",
          function () {
            _this.dialogVisible = false;
          }
        );
        return false;
      }

      if (
        _this.listMenuForm.startTime != "" &&
        _this.listMenuForm.endTime != "" &&
        _this.listMenuForm.startTime != null &&
        _this.listMenuForm.endTime != null
      ) {
        if (
          _this.listMenuForm.endTime.getTime() -
            _this.listMenuForm.startTime.getTime() >
          3600 * 1000 * 24 * 31
        ) {
          _this.dialogVisible = true;
          _this.$propMessage(
            "最多可導出31天內訂單，請重新選擇",
            "error",
            function () {
              _this.dialogVisible = false;
              _this.listMenuForm.startTime = "";
              _this.listMenuForm.endTime = "";
            }
          );
        } else {
          _this.downExcel(shipment);
        }
      } else {
        _this.downExcel(shipment);
      }
    },
    //上传
    beforeExcelUpload(file) {
      let _this = this;
      let result = _this.$checkData(file.name);
      if (file === "" && result === false) {
        _this.dialogVisible = true;
        _this.$propMessage("請選擇需要導入的Excel文件！", "error", function () {
          _this.dialogVisible = false;
        });
        return false;
      }
    },
    // 上传excel超过限制回调函数
    handleExceed() {
      this.dialogVisible = true;
      this.$propMessage("最多上傳1個文件！", "error", function () {
        this.dialogVisible = false;
      });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    // excel上传成功
    successExcel(res, file, fileList) {
      let _this = this;
      this.showMoadl = false;
      if (res.code === "00000") {
        _this.dialogVisible = true;
        _this.$propMessage("上傳成功", "success", function () {
          _this.dialogVisible = false;
        });
        _this.$refs.excelUpload.clearFiles();
      } else {
        _this.dialogVisible = true;
        _this.$propMessage(res.data, "error", function () {
          _this.dialogVisible = false;
        });
        _this.$refs.excelUpload.clearFiles();
      }
    },
    // excel上传失败
    errorExcel(err, file, fileList) {
      let _this = this;
      _this.$refs.excelUpload.clearFiles();
      _this.dialogVisible = true;
      _this.$propMessage(err.message + ",請重新上傳", "error", function () {
        _this.dialogVisible = false;
      });
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
    },
    // 下载excel
    downExcel(shipment) {
      let _this = this;
      _this.currentPage = 1;
      let startTime, endTime;
      let role = localStorage.getItem("testRole");
      if (
        _this.listMenuForm.startTime === "" ||
        _this.listMenuForm.startTime === null
      ) {
        startTime = "";
      } else {
        startTime = _this.$formatDate(_this.listMenuForm.startTime);
      }
      if (
        _this.listMenuForm.endTime === "" ||
        _this.listMenuForm.endTime === null
      ) {
        endTime = "";
      } else {
        endTime = _this.$formatDate(_this.listMenuForm.endTime);
      }
      let url =
        "/request/order/exportShipmentOrderExcel?pageNo=" +
        _this.currentPage +
        "&pageSize=99999999" +
        "&userEmail=" +
        (_this.listMenuForm.userEmail === ""
          ? ""
          : _this.listMenuForm.userEmail) +
        "&orderType=" +
        (_this.listMenuForm.orderType === undefined
          ? ""
          : _this.listMenuForm.orderType === ""
          ? ""
          : Number(_this.listMenuForm.orderType)) +
        "&orderNum=" +
        (_this.listMenuForm.orderId === "" ? "" : _this.listMenuForm.orderId) +
        "&orderStatus=" +
        (_this.orderStatus === "" ? "" : _this.orderStatus) +
        "&trackingNumber=" +
        (_this.listMenuForm.trackingNumber === ""
          ? ""
          : _this.listMenuForm.trackingNumber) +
        "&name=" +
        (_this.listMenuForm.name === "" ? "" : _this.listMenuForm.name) +
        "&mobile=" +
        (_this.listMenuForm.mobile === "" ? "" : _this.listMenuForm.mobile) +
        "&startTime=" +
        startTime +
        "&endTime=" +
        endTime +
        "&role=" +
        role +
        "&shipment=" +
        shipment +
        "&area=" +
        this.downExcelType;
      _this.$exportExcel(
        url,
        "GET",
        {},
        `出貨訂單${startTime.substring(0, 10)}-${endTime.substring(0, 10)}`
      );
      this.showMoadl = false;
      // _this.$get(url, _this.$GLOBAL.jsonConfig).then(res => {
      //   if (res.code === "20009") {
      //     _this.dialogVisible = true;
      //     _this.$propMessage(res.message, "error", function() {
      //       _this.dialogVisible = false;
      //     });
      //   } else {
      //     _this.$exportExcel(
      //       url,
      //       "GET",
      //       {},
      //       `出貨訂單${startTime.substring(0, 10)}-${endTime.substring(0, 10)}`
      //     );
      //   }
      // });
    },
  },
  components: {
    DiaMess,
  },
  watch: {
    orderStatus(val) {
      console.log("val", val);
    },
  },
};
</script>

<style lang="less" scoped>
.search-content {
  width: 100%;
  .ListMenu {
    display: flex;
  }
  .MenuBtnWrap {
    justify-content: flex-start;
    margin-top: 30px;
    .MenuBtnWrap_left {
      width: 100%;
      color: #292929;
      display: flex;
      align-items: center;
      overflow: auto;
      span:first-child {
        flex-shrink: 0;
      }

      .tags {
        width: 94%;
        overflow: auto;
        white-space: nowrap;
        display: flex;
        justify-content: flex-start;
      }
    }
  }
  .MenuBtnWrap_right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .colorfade {
      color: #6c3dea;
      border: 1px solid #6c3dea;
      background: white;
    }
    .colorfade:hover {
      font-weight: 600;
    }
  }
}
@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;

      .searchItem {
        margin-right: 0.4rem;
        margin-bottom: 0.2rem;
      }
    }

    .MenuBtnWrap {
      flex: 1;
    }
  }
  .MenuBtnWrap_right {
    margin-top: -59px;
  }
}
@media screen and (max-width: 769px) {
  .MenuBtnWrap_right {
    margin-top: 0px;
  }
}
.areaSelect {
  font-size: 14px;
  display: flex;
  margin-top: 30px;
  align-items: center;
}
.colorfades {
  width: 1rem;
  height: 0.35rem;
  line-height: 0.35rem;
  border: 1px solid #6c3dea;
  text-align: center;
  border-radius: 0.04rem;
  color: #6c3dea;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/member/moneyOrderItem.vue